function mmInitLipscoreWidgets() {
  if (window.lipscore && typeof window.lipscore.initWidgets === 'function') {
    window.lipscore.initWidgets();
  }
}

window.mmInitLipscoreWidgets = mmInitLipscoreWidgets;

document.addEventListener('facet:update', function () {
  setTimeout(mmInitLipscoreWidgets, 300);
});

document.addEventListener('shopify:section:load', mmInitLipscoreWidgets);

window.addEventListener('load', function () {
  mmInitLipscoreWidgets();
  setTimeout(mmInitLipscoreWidgets, 500);
  setTimeout(mmInitLipscoreWidgets, 1500);
});

if (window.location.href.includes("/loyalty")) {
  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get("email");

  if (email) {
    console.log("Email:", email);

    const emailInput = document.getElementById("email");
    if (emailInput) {
      emailInput.value = email;
    }
  } else {
    console.log("Email parameter not found in the URL.");
  }
}
